export const getSxArray = sx => {
  if (sx) {
    return Array.isArray(sx) ? sx : [sx]
  }
  return []
}
